module.exports = __webpack_public_path__ + "static/img/no4.d96ce95e.svg";